import { useMutation, useQueryClient } from "react-query";

import axios from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";
import { GetScenarioListKey } from "./useScenarioList";
import { ScenarioStickListKey } from "./useScenarioSticks";
import { StickDataQueryKey } from "./useStickData";

export interface DeleteStickParams {
  scenarioId: string;
  stickId: string;
}

const useDeleteStick = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ scenarioId, stickId }: DeleteStickParams) => {
      const response = await axios.delete(
        `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario/${scenarioId}/sticks/${stickId}`
      );
      return response.data;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(ScenarioStickListKey);
        await queryClient.invalidateQueries(StickDataQueryKey);
        await queryClient.invalidateQueries(GetScenarioListKey);
      }
    }
  );
};

export default useDeleteStick;
